<!-- Заказы -->
<template>
  <li
    v-if="canSeePage('orders')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Orders')"
    @mouseup="handleMiddleClick($event, 'Orders')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Orders')"
    :class="{ active: activeItem === 'orders' }"
    :title="collapsed ? 'Заказы' : ''"
  >
    <div class="link-icon_box">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        width="24"
        height="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 2H8C4.5 2 3 4 3 7V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V7C21 4 19.5 2 16 2ZM8 12.25H12C12.41 12.25 12.75 12.59 12.75 13C12.75 13.41 12.41 13.75 12 13.75H8C7.59 13.75 7.25 13.41 7.25 13C7.25 12.59 7.59 12.25 8 12.25ZM16 17.75H8C7.59 17.75 7.25 17.41 7.25 17C7.25 16.59 7.59 16.25 8 16.25H16C16.41 16.25 16.75 16.59 16.75 17C16.75 17.41 16.41 17.75 16 17.75ZM18.5 9.25H16.5C14.98 9.25 13.75 8.02 13.75 6.5V4.5C13.75 4.09 14.09 3.75 14.5 3.75C14.91 3.75 15.25 4.09 15.25 4.5V6.5C15.25 7.19 15.81 7.75 16.5 7.75H18.5C18.91 7.75 19.25 8.09 19.25 8.5C19.25 8.91 18.91 9.25 18.5 9.25Z"
          fill="#00bfa5"
        />
      </svg>
    </div>
    <span v-if="!collapsed" class="nav-link">Заказы</span>
  </li>
</template>

<script>
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "OrdersItem",
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
